var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import ADD_ORDER_MODELS from 'api/mutations/ADD_ORDER_MODELS';
import COPY_ORDER_MODEL_VARIANTS_FROM_MODEL from 'api/mutations/COPY_ORDER_MODEL_VARIANTS_FROM_MODEL';
import REMOVE_ORDER_MODELS from 'api/mutations/REMOVE_ORDER_MODELS';
import SET_ORDER_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE from 'api/mutations/SET_ORDER_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE';
import SET_ORDER_COMPONENT_VARIANT_TO_NOT_READY from 'api/mutations/SET_ORDER_COMPONENT_VARIANT_TO_NOT_READY';
import SET_ORDER_COMPONENT_VARIANT_TO_READY from 'api/mutations/SET_ORDER_COMPONENT_VARIANT_TO_READY';
import SET_ORDER_DELIVERY_DATE from 'api/mutations/SET_ORDER_DELIVERY_DATE';
import SET_ORDER_MODEL_TO_NOT_READY from 'api/mutations/SET_ORDER_MODEL_TO_NOT_READY';
import SET_ORDER_MODEL_TO_READY from 'api/mutations/SET_ORDER_MODEL_TO_READY';
import UPDATE_ORDER_MODEL_VARIANT from 'api/mutations/UPDATE_ORDER_MODEL_VARIANT';
import GET_MODEL_SPECIFICATION_VARIANTS from 'api/queries/GET_MODEL_SPECIFICATION_VARIANTS';
import GET_ORDER from 'api/queries/GET_ORDER';
import GET_ORDER_MODEL_VARIANTS from 'api/queries/GET_ORDER_MODEL_VARIANTS';
import GET_ORDER_SUPPLIERS from 'api/queries/GET_ORDER_SUPPLIERS';
import client from '../api/environment';
const initialState = {
    item: null,
    orderModels: [],
    removedSpecificationIds: [],
    orderSuppliers: [],
    productionVolume: {
        modelSpecificationVariants: {},
        orderModelVariants: {},
    },
    status: {
        fetch: 'idle',
        add: 'idle',
        remove: 'idle',
        other: 'idle',
        fetchProductionVolume: 'idle',
        fetchOrderVolume: 'idle',
        setOrderDeliveryDate: 'idle',
    },
    errors: {
        fetch: null,
        add: null,
        remove: null,
        other: null,
        fetchProductionVolume: null,
        fetchOrderVolume: null,
        setOrderDeliveryDate: null,
    },
    refetchFlags: {
        fetch: false,
        add: false,
        remove: false,
        other: false,
        fetchProductionVolume: false,
        fetchOrderVolume: false,
        setOrderDeliveryDate: false,
        modelsList: false,
    },
};
export const fetchOrder = createAsyncThunk('ordersCreator/fetchOrder', (orderId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: GET_ORDER,
            variables: {
                id: orderId,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchSpecificationModelVariants = createAsyncThunk('ordersCreator/fetchSpecificationModelVariants', (modelSpecificationId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    try {
        const response = yield client.query({
            query: GET_MODEL_SPECIFICATION_VARIANTS,
            variables: {
                modelSpecificationId,
            },
            fetchPolicy: 'network-only',
        });
        return {
            colors: (_b = (_a = response.data.node.colors) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map((color) => color.node),
            sizes: (_d = (_c = response.data.node.sizes) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.map((size) => size.node),
            variants: (_f = (_e = response.data.node.variants) === null || _e === void 0 ? void 0 : _e.edges) === null || _f === void 0 ? void 0 : _f.map((variant) => variant.node),
        };
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchOrderSuppliers = createAsyncThunk('ordersCreator/fetchOrderSuppliers', (orderId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: GET_ORDER_SUPPLIERS,
            variables: {
                id: orderId,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.node.componentVariantsBySuppliers;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchOrderModelVariants = createAsyncThunk('ordersCreator/fetchOrderModelVariants', (id, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _g, _h, _j, _k, _l, _m;
    try {
        const response = yield client.query({
            query: GET_ORDER_MODEL_VARIANTS,
            variables: {
                id,
            },
            fetchPolicy: 'network-only',
        });
        return {
            colors: (_h = (_g = response.data.node.colors) === null || _g === void 0 ? void 0 : _g.edges) === null || _h === void 0 ? void 0 : _h.map((color) => color.node),
            sizes: (_k = (_j = response.data.node.sizes) === null || _j === void 0 ? void 0 : _j.edges) === null || _k === void 0 ? void 0 : _k.map((size) => size.node),
            variants: (_m = (_l = response.data.node.variants) === null || _l === void 0 ? void 0 : _l.edges) === null || _m === void 0 ? void 0 : _m.map((variant) => variant.node),
            modelReady: response.data.node.modelReady,
        };
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addOrderModels = createAsyncThunk('ordersCreator/addOrderModels', ({ orderId, modelSpecificationId }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const orderModelData = yield client.mutate({
            mutation: ADD_ORDER_MODELS,
            variables: {
                modelSpecificationIds: [modelSpecificationId],
                orderId,
            },
        });
        return {
            id: orderModelData.data.addOrderModelNodes.id,
            modelSpecificationNode: {
                id: modelSpecificationId,
            },
        };
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const removeOrderModels = createAsyncThunk('ordersCreator/removeOrderModels', (orderModelId, { getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _o;
    const state = getState();
    const model = state.ordersCreator.orderModels.find((m) => m.id === orderModelId);
    const specId = (_o = model === null || model === void 0 ? void 0 : model.modelSpecificationNode) === null || _o === void 0 ? void 0 : _o.id;
    try {
        const orderModelData = yield client.mutate({
            mutation: REMOVE_ORDER_MODELS,
            variables: { orderModelIds: [orderModelId] },
        });
        return {
            id: orderModelId,
            specId,
            removed: orderModelData.data.removeOrderModelNodes.removed,
        };
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const updateOrderModelVariant = createAsyncThunk('ordersCreator/updateOrderModelVariant', ({ variantId, value }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: UPDATE_ORDER_MODEL_VARIANT,
            variables: {
                variantsQuantity: [[variantId, value === '' ? '0' : value.replace(/\D/g, '')]],
            },
        });
        return {
            variantId,
            value,
        };
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const copyOrderVariantsFromModel = createAsyncThunk('ordersCreator/copyOrderVariantsFromModel', ({ orderModelId }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const orderModelData = yield client.mutate({
            mutation: COPY_ORDER_MODEL_VARIANTS_FROM_MODEL,
            variables: {
                orderModelId,
            },
        });
        return orderModelData.data.copyOrderModelVariantsFromModel.orderModel.id;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setOrderModelReady = createAsyncThunk('ordersCreator/setOrderModelReady', (orderModelId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const orderModelData = yield client.mutate({
            mutation: SET_ORDER_MODEL_TO_READY,
            variables: { orderModelId },
        });
        return orderModelData.data.setOrderModelToReady.orderModel.id;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setOrderModelNotReady = createAsyncThunk('ordersCreator/setOrderModelNotReady', (orderModelId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const orderModelData = yield client.mutate({
            mutation: SET_ORDER_MODEL_TO_NOT_READY,
            variables: { orderModelId },
        });
        return orderModelData.data.setOrderModelToReady.orderModel.id;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setOrderComponentVariantConsumptionOverride = createAsyncThunk('ordersCreator/setOrderComponentVariantConsumptionOverride', ({ orderComponentVariantId, value, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const orderModelData = yield client.mutate({
            mutation: SET_ORDER_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE,
            variables: { orderComponentVariantId, value },
        });
        return orderModelData.data.setOrderComponentVariantToReady.orderComponentVariant.id;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setOrderComponentVariantToReady = createAsyncThunk('ordersCreator/setOrderComponentVariantToReady', (orderComponentVariantId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const orderModelData = yield client.mutate({
            mutation: SET_ORDER_COMPONENT_VARIANT_TO_READY,
            variables: { orderComponentVariantId },
        });
        return orderModelData.data.setOrderComponentVariantToReady.orderComponentVariant.id;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setOrderComponentVariantToNotReady = createAsyncThunk('ordersCreator/setOrderComponentVariantToNotReady', (orderComponentVariantId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const orderModelData = yield client.mutate({
            mutation: SET_ORDER_COMPONENT_VARIANT_TO_NOT_READY,
            variables: { orderComponentVariantId },
        });
        return orderModelData.data.setOrderComponentVariantToNotReady.orderComponentVariant.id;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setOrderDeliveryDate = createAsyncThunk('ordersCreator/setOrderDeliveryDate', ({ orderId, orderDeliveryDate }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _p, _q;
    try {
        const response = yield client.mutate({
            mutation: SET_ORDER_DELIVERY_DATE,
            variables: {
                orderId,
                orderDeliveryDate,
            },
        });
        return (_q = (_p = response.data) === null || _p === void 0 ? void 0 : _p.setOrderDeliveryDate) === null || _q === void 0 ? void 0 : _q.order;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
const ordersCreatorSlice = createSlice({
    name: 'ordersCreator',
    initialState,
    reducers: {
        resetOrdersCreatorState(state) {
            state.item = null;
            state.orderModels = [];
            state.status.fetch = 'idle';
            state.errors.fetch = null;
            state.refetchFlags.fetch = false;
        },
        setOrderModelVariantsRefetch(state) {
            state.refetchFlags.fetchProductionVolume = true;
        },
        setOrderVolumeRefetch(state) {
            state.refetchFlags.fetchOrderVolume = true;
        },
        resetOrderVolume(state) {
            state.orderSuppliers = [];
            state.status.fetchOrderVolume = 'idle';
        },
        setOrdersCreatorRefetchFlag(state, action) {
            state.refetchFlags.fetch = action.payload;
        },
        updateStoreModelVariants: (state, action) => {
            const { variantId, value } = action.payload;
            const itemIndex = state.productionVolume.orderModelVariants.variants.findIndex((item) => item.id === variantId);
            if (itemIndex !== -1) {
                state.productionVolume.orderModelVariants.variants[itemIndex] = Object.assign(Object.assign({}, state.productionVolume.orderModelVariants.variants[itemIndex]), { quantity: value.replace(/\D/g, '') });
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrder.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchOrder.fulfilled, (state, action) => {
            const models = action.payload.models.edges.map((model) => model.node);
            state.status.fetch = 'succeeded';
            state.item = action.payload;
            state.orderModels = models;
            state.refetchFlags.fetch = false;
            state.refetchFlags.modelsList = false;
        })
            .addCase(fetchOrder.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.errors.fetch =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetch = false;
        })
            // fetchOrderSuppliers
            .addCase(fetchOrderSuppliers.pending, (state) => {
            state.status.fetchOrderVolume = 'loading';
        })
            .addCase(fetchOrderSuppliers.fulfilled, (state, action) => {
            state.status.fetchOrderVolume = 'succeeded';
            state.orderSuppliers = action.payload;
            state.refetchFlags.fetch = false;
            state.refetchFlags.other = false;
            state.refetchFlags.fetchOrderVolume = false;
        })
            .addCase(fetchOrderSuppliers.rejected, (state, action) => {
            state.status.fetchOrderVolume = 'failed';
            state.errors.fetchOrderVolume =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetch = false;
            state.refetchFlags.other = false;
            state.refetchFlags.fetchOrderVolume = false;
        })
            // fetchSpecificationModelVariants
            .addCase(fetchSpecificationModelVariants.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchSpecificationModelVariants.fulfilled, (state, action) => {
            state.status.fetch = 'succeeded';
            state.productionVolume.modelSpecificationVariants = action.payload;
            state.refetchFlags.fetch = false;
            state.refetchFlags.other = false;
        })
            .addCase(fetchSpecificationModelVariants.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.errors.fetch =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetch = false;
            state.refetchFlags.other = false;
        })
            // fetchOrderModelVariants
            .addCase(fetchOrderModelVariants.pending, (state) => {
            state.status.fetchProductionVolume = 'loading';
        })
            .addCase(fetchOrderModelVariants.fulfilled, (state, action) => {
            state.status.fetchProductionVolume = 'succeeded';
            state.productionVolume.orderModelVariants = action.payload;
            state.refetchFlags.fetchProductionVolume = false;
            state.refetchFlags.other = false;
            const model = state.orderModels.find((m) => m.id === action.meta.arg);
            if (model)
                model.modelReady = action.payload.modelReady;
        })
            .addCase(fetchOrderModelVariants.rejected, (state, action) => {
            state.status.fetchProductionVolume = 'failed';
            state.errors.fetchProductionVolume =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetchProductionVolume = false;
            state.refetchFlags.other = false;
        })
            // addOrderModel
            .addCase(addOrderModels.pending, (state) => {
            state.status.add = 'loading';
        })
            .addCase(addOrderModels.fulfilled, (state, action) => {
            state.status.add = 'succeeded';
            const index = state.orderModels.findIndex((model) => model.id === action.payload.id);
            if (index === -1) {
                state.orderModels = [...state.orderModels, action.payload];
            }
            state.refetchFlags.fetch = true;
            state.refetchFlags.other = true;
            state.refetchFlags.fetchProductionVolume = true;
            state.refetchFlags.fetchOrderVolume = true;
            state.refetchFlags.modelsList = true;
            state.status.fetchProductionVolume = 'idle';
        })
            .addCase(addOrderModels.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            // removeOrderModels
            .addCase(removeOrderModels.pending, (state) => {
            // state.items = state.items.filter((order) => order.id !== action.payload);
            state.status.remove = 'loading';
        })
            .addCase(removeOrderModels.fulfilled, (state, action) => {
            state.status.remove = 'succeeded';
            const index = state.orderModels.findIndex((model) => model.id === action.payload.id);
            if (index !== -1 && action.payload.removed) {
                state.orderModels.splice(index, 1);
            }
            if (action.payload.specId) {
                state.removedSpecificationIds = [...state.removedSpecificationIds, action.payload.specId];
            }
            state.refetchFlags.fetch = true;
            state.refetchFlags.other = true;
            state.refetchFlags.fetchProductionVolume = true;
            state.refetchFlags.fetchOrderVolume = true;
            state.refetchFlags.modelsList = true;
            state.status.fetchProductionVolume = 'idle';
        })
            .addCase(removeOrderModels.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove = action.payload;
        })
            // updateOrderModelVariant
            .addCase(updateOrderModelVariant.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(updateOrderModelVariant.fulfilled, (state) => {
            state.status.other = 'succeeded';
        })
            .addCase(updateOrderModelVariant.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
        })
            // copyOrderVariantsFromModel
            .addCase(copyOrderVariantsFromModel.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(copyOrderVariantsFromModel.fulfilled, (state) => {
            state.status.other = 'succeeded';
            state.refetchFlags.fetch = true;
            state.refetchFlags.other = true;
            state.refetchFlags.fetchProductionVolume = true;
        })
            .addCase(copyOrderVariantsFromModel.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
        })
            // setOrderModelReady
            .addCase(setOrderModelReady.pending, (state, action) => {
            state.status.other = 'loading';
            if (state.productionVolume.orderModelVariants) {
                state.productionVolume.orderModelVariants.modelReady = true;
            }
            const model = state.orderModels.find((m) => m.id === action.meta.arg);
            if (model)
                model.modelReady = true;
        })
            .addCase(setOrderModelReady.fulfilled, (state) => {
            state.status.other = 'succeeded';
        })
            .addCase(setOrderModelReady.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
            if (state.productionVolume.orderModelVariants) {
                state.productionVolume.orderModelVariants.modelReady = false;
            }
            const model = state.orderModels.find((m) => m.id === action.meta.arg);
            if (model)
                model.modelReady = false;
        })
            // setOrderModelNotReady
            .addCase(setOrderModelNotReady.pending, (state, action) => {
            state.status.other = 'loading';
            if (state.productionVolume.orderModelVariants) {
                state.productionVolume.orderModelVariants.modelReady = false;
            }
            const model = state.orderModels.find((m) => m.id === action.meta.arg);
            if (model)
                model.modelReady = false;
        })
            .addCase(setOrderModelNotReady.fulfilled, (state) => {
            state.status.other = 'succeeded';
        })
            .addCase(setOrderModelNotReady.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
            if (state.productionVolume.orderModelVariants) {
                state.productionVolume.orderModelVariants.modelReady = true;
            }
            const model = state.orderModels.find((m) => m.id === action.meta.arg);
            if (model)
                model.modelReady = true;
        })
            // setOrderComponentVariantConsumptionOverride
            .addCase(setOrderComponentVariantConsumptionOverride.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(setOrderComponentVariantConsumptionOverride.fulfilled, (state) => {
            state.status.other = 'succeeded';
            state.refetchFlags.fetch = true;
            state.refetchFlags.other = true;
            state.refetchFlags.fetchOrderVolume = true;
        })
            .addCase(setOrderComponentVariantConsumptionOverride.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
        })
            // setOrderComponentVariantToReady
            .addCase(setOrderComponentVariantToReady.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(setOrderComponentVariantToReady.fulfilled, (state) => {
            state.status.other = 'succeeded';
            state.refetchFlags.fetch = true;
            state.refetchFlags.other = true;
            state.refetchFlags.fetchOrderVolume = true;
        })
            .addCase(setOrderComponentVariantToReady.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
        })
            // setOrderComponentVariantToNotReady
            .addCase(setOrderComponentVariantToNotReady.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(setOrderComponentVariantToNotReady.fulfilled, (state) => {
            state.status.other = 'succeeded';
            state.refetchFlags.fetch = true;
            state.refetchFlags.other = true;
            state.refetchFlags.fetchOrderVolume = true;
        })
            .addCase(setOrderComponentVariantToNotReady.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.other = action.payload;
        })
            // setOrderDeliveryDate
            .addCase(setOrderDeliveryDate.pending, (state) => {
            state.status.setOrderDeliveryDate = 'loading';
        })
            .addCase(setOrderDeliveryDate.fulfilled, (state, action) => {
            state.status.setOrderDeliveryDate = 'succeeded';
            if (state.item && action.payload) {
                state.item = Object.assign(Object.assign({}, state.item), { orderDeliveryDate: action.payload.orderDeliveryDate });
            }
            state.refetchFlags.setOrderDeliveryDate = false;
        })
            .addCase(setOrderDeliveryDate.rejected, (state, action) => {
            state.status.setOrderDeliveryDate = 'failed';
            state.errors.setOrderDeliveryDate = action.payload;
            state.refetchFlags.setOrderDeliveryDate = false;
        })
            .addMatcher((action) => action.type === 'specificationsFolders/fetchSpecificationsFolders/fulfilled' ||
            action.type === 'specifications/fetchSpecifications/fulfilled', (state) => {
            state.removedSpecificationIds = [];
        });
    },
});
export const { resetOrdersCreatorState, setOrderModelVariantsRefetch, setOrderVolumeRefetch, setOrdersCreatorRefetchFlag, resetOrderVolume, updateStoreModelVariants, } = ordersCreatorSlice.actions;
export const selectOrdersCreatorStatus = (state) => state.ordersCreator.status;
export const selectOrdersCreatorErrors = (state) => state.ordersCreator.errors;
export const selectOrdersCreatorRefetchFlags = (state) => state.ordersCreator.refetchFlags;
export const selectOrdersCreatorItem = (state) => state.ordersCreator.item;
export const selectOrdersCreatorSuppliers = (state) => state.ordersCreator.orderSuppliers;
export const selectOrdersCreatorModelsAssigned = (state) => state.ordersCreator.orderModels;
export const selectOrdersCreatorProductionVolume = (state) => state.ordersCreator.productionVolume;
export const selectIsModelAssigned = (id) => createSelector((state) => state.ordersCreator.orderModels, (orderModels) => orderModels.some((model) => model.modelSpecificationNode.id === id));
export const selectIsModelRemoved = (id) => createSelector((state) => state.ordersCreator.removedSpecificationIds, (removedIds) => removedIds.includes(id));
export const selectModelAssignedId = (id) => createSelector((state) => state.ordersCreator.orderModels, (orderModels) => orderModels.find((model) => model.modelSpecificationNode.id === id));
export const selectModelById = (modelId) => createSelector((state) => state.ordersCreator.orderModels || [], (orderModels) => orderModels.find((model) => String(model.id) === String(modelId)) || null);
export default ordersCreatorSlice.reducer;
